/**
 * Monitoring Service Public API
 *
 * External code should ONLY import from this file.
 * Provider implementations are not exposed.
 */

import { isOnPrem } from '../../config'
import useDatadogMonitoring from './hooks/useDatadogMonitoring'
import useNoOpMonitoring from './hooks/useNoOpMonitoring'

// Compile-time hook selection based on environment
// At build time, webpack replaces process.env.REACT_APP_ENV,
// allowing dead code elimination to remove unused implementations
let useMonitoringImpl
if (isOnPrem) {
  useMonitoringImpl = useNoOpMonitoring
} else {
  useMonitoringImpl = useDatadogMonitoring
}
export const useMonitoring = useMonitoringImpl

// Types
export type { MonitoringHook } from './types'
export type { DatadogConfig } from './hooks/useDatadogMonitoring'
// For backward compatibility
export type { MonitoringHook as MonitoringProvider } from './types'
